'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventTypes = exports.langs = exports.customValidate = exports.transformErrors = exports.sanitizeString = exports.extractCommonStatuses = exports.extractStatuses = exports.getIdFromUrl = exports.sortData = exports.renameKeysComplex = exports.renameKeys = exports.arrifyObject3 = exports.arrifyObject2 = exports.arrifyObject = exports.stringifyObject = exports.getSchema = exports.parseFormData = exports.parseUISchema = exports.parseSchema = exports.getFieldSettings = exports.parseMask = exports.formatDateISO = exports.noop = exports.tableStyles = exports.availableDates = exports.statusTypes = exports.countries = exports.countriesISO2 = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _promisePolyfill = require('promise-polyfill');

var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);

var _escapeStringRegexp = require('escape-string-regexp');

var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _countryTelephoneData = require('country-telephone-data');

var _countryTelephoneData2 = _interopRequireDefault(_countryTelephoneData);

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _getFilterFields = require('./getFilterFields');

var _getFilterFields2 = _interopRequireDefault(_getFilterFields);

var _buildDataSourceUrl = require('./buildDataSourceUrl');

var _buildDataSourceUrl2 = _interopRequireDefault(_buildDataSourceUrl);

var _createDatasourceMappings = require('./createDatasourceMappings');

var _createDatasourceMappings2 = _interopRequireDefault(_createDatasourceMappings);

var _fieldActions = require('../constants/fieldActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var countriesISO2 = exports.countriesISO2 = [_countryTelephoneData2.default.allCountries[_countryTelephoneData2.default.iso2Lookup.ru], _countryTelephoneData2.default.allCountries[_countryTelephoneData2.default.iso2Lookup.by], _countryTelephoneData2.default.allCountries[_countryTelephoneData2.default.iso2Lookup.kz], _countryTelephoneData2.default.allCountries[_countryTelephoneData2.default.iso2Lookup.am]];

var countries = exports.countries = [{
  name: 'Россия',
  value: 'ru'
}, {
  name: 'Беларусь',
  value: 'by'
}, {
  name: 'Казахстан',
  value: 'kz'
}, {
  name: 'Армения',
  value: 'am'
}];

var statusTypes = exports.statusTypes = [{
  name: 'Начальный',
  value: 'initial'
}, {
  name: 'Обычный',
  value: 'normal'
}, {
  name: 'Конечный',
  value: 'final'
}];

var availableDates = exports.availableDates = [{
  name: 'Без ограничений',
  value: 'any'
}, {
  name: 'Только в будущем',
  value: 'future'
}, {
  name: 'Только в прошлом',
  value: 'past'
}];

var tableStyles = exports.tableStyles = {
  table: {
    marginTop: -40
  },
  formDataTable: {
    marginTop: 0,
    padding: '0 16px 16px'
  }
};

var noop = exports.noop = function noop() {
  return _promisePolyfill2.default.resolve();
};

var formatDateISO = exports.formatDateISO = function formatDateISO(date) {
  return date ? (0, _moment2.default)(date).format('YYYY-MM-DD HH:mm:ss') : undefined;
};

var types = {
  text: 'string',
  textarea: 'string',
  masked: 'string',
  email: 'string',
  password: 'string',
  URL: 'string',
  number: 'integer',
  checkbox: 'boolean',
  checkboxMultiple: 'array',
  radio: 'string',
  dropdown: 'string',
  datepicker: 'string',
  fio: 'string',
  name: 'string',
  staticText: 'string',
  button: 'string',
  phoneInput: 'string',
  filesAsync: 'array'
};

var formats = {
  email: 'email',
  URL: 'uri'
};

var widgets = {
  textarea: 'textarea',
  masked: 'maskedInput',
  number: 'updown',
  password: 'password',
  radio: 'radio',
  checkboxMultiple: 'checkboxes',
  dropdown: 'select',
  datepicker: 'dateTime',
  staticText: 'staticText',
  button: 'button',
  phoneInput: 'phoneInput',
  filesAsync: 'filesAsync'
};

var parseMask = exports.parseMask = function parseMask(_ref) {
  var dialCode = _ref.dialCode,
      format = _ref.format;
  return (0, _from2.default)(dialCode).reduce(function (result, current) {
    return result.replace('.', current);
  }, format).replace(/\./g, '9');
};

var getCountriesFromEnums = function getCountriesFromEnums(enums, enumsNames) {
  return enums.map(function (item, idx) {
    return {
      code: item,
      name: enumsNames[idx]
    };
  });
};

var getFieldSettings = exports.getFieldSettings = function getFieldSettings(form) {
  var settings = {
    readonly: [],
    hidden: [],
    preset: {}
  };

  if (form.fieldsSettings) {
    form.fieldsSettings.forEach(function (field) {
      settings.preset[field.id] = field.value;

      switch (field.action) {
        case _fieldActions.SET_HIDDEN:
          settings.hidden.push(field.id);
          break;
        case _fieldActions.SET_READONLY:
          settings.readonly.push(field.id);
          break;
        default:
          break;
      }
    });
  }

  return settings;
};

var parseSchema = exports.parseSchema = function parseSchema(data) {
  if (!data) return;

  var required = [];
  var properties = {};
  var datasourceFields = [];

  if (data && data.length) {
    data.forEach(function (field) {
      var key = field.key,
          type = field.type,
          title = field.title,
          isRequired = field.isRequired,
          itemsDataSource = field.itemsDataSource,
          itemsDataSourceId = field.itemsDataSourceId,
          maxLength = field.maxLength,
          minLength = field.minLength,
          mask = field.mask,
          items = field.items,
          hideLabel = field.hideLabel,
          country = field.country,
          patternField = field.pattern,
          masterFieldId = field.masterFieldId;

      if (!key) return;

      var datasourceFieldsIndex = -1;

      if (itemsDataSourceId) {
        /*datasourceFields[0] = {
          property: key,
          id: itemsDataSourceId,
        }*/

        datasourceFields.push({
          property: key,
          id: itemsDataSourceId
        });

        datasourceFieldsIndex = datasourceFields.map(function (f) {
          return f.property;
        }).indexOf(key);
      }

      properties[key] = {
        type: types[type],
        format: formats[type],
        hideLabel: hideLabel,
        title: title
      };

      if (field.itemsDataSourceFilters) {
        properties[key].itemsDataSourceFilters = field.itemsDataSourceFilters;
      }

      if (type === 'dropdown' || type === 'radio' || type === 'phoneInput') {
        properties[key].enum = [];
        properties[key].enumNames = [];
        if (field.enum && field.enumNames) {
          properties[key].enum = _ramda2.default.prop('enum', field);
          properties[key].enumNames = _ramda2.default.prop('enumNames', field);

          if (type === 'phoneInput') {
            properties[key].countries = getCountriesFromEnums(properties[key].enum, properties[key].enumNames);
          }
        }

        if (itemsDataSource && itemsDataSource.length) {
          properties[key].enum = _ramda2.default.map(_ramda2.default.prop('id'), itemsDataSource);
          properties[key].enumNames = _ramda2.default.map(_ramda2.default.prop('name'), itemsDataSource);
        }
      } else if (type === 'checkboxMultiple') {
        properties[key].uniqueItems = true;
        if (itemsDataSource && itemsDataSource.length) {
          properties[key].items = {
            type: 'string',
            enum: _ramda2.default.map(_ramda2.default.prop('id'), itemsDataSource),
            enumNames: _ramda2.default.map(_ramda2.default.prop('name'), itemsDataSource)
          };
        } else if (items) {
          if (items.enum && items.enumNames) {
            properties[key].items = items;
          }
        } else {
          properties[key].items = {
            type: 'array',
            enum: items || ['']
          };
        }
      }

      if (type === 'staticText' || type === 'button') {
        properties[key].hideLabel = true;
      }

      if (minLength && minLength > 0) {
        properties[key].minLength = minLength;
      }

      if (maxLength && maxLength > 0) {
        properties[key].maxLength = maxLength;
      }

      if (mask) {
        //        properties[key].pattern = '^\\+7\\(\\d{3}\\)\\d{3}-\\d{2}-\\d{2}$'
        var maskEscaped = (0, _escapeStringRegexp2.default)(mask);
        properties[key].pattern = '^' + maskEscaped.replace(/a/g, '\\w').replace(/9/g, '\\d') + '$';
        properties[key].mask = mask;
      }
      if (patternField) {
        properties[key].pattern = patternField;
      }
      if (type === 'fio') {
        properties[key].pattern = '^[а-яА-ЯёЁ .\\-]+$';
        properties[key].validator = 'fio';
      }
      if (type === 'name') {
        properties[key].pattern = '^[A-zА-яЁё-]+$';
        properties[key].validator = 'name';
      }
      if (type === 'phoneInput') {
        var countryCode = country || countries[0].value;

        var _R$compose = _ramda2.default.compose(_ramda2.default.props(['format', 'dialCode']), _ramda2.default.find(_ramda2.default.propEq('iso2', countryCode)))(countriesISO2),
            _R$compose2 = (0, _slicedToArray3.default)(_R$compose, 2),
            pattern = _R$compose2[0],
            dialCode = _R$compose2[1];

        var resolvedPattern = patternField || pattern;
        var patternRE = '^' + (0, _escapeStringRegexp2.default)(resolvedPattern).replace(/\./g, 'd') + '$';
        var _mask = parseMask({ dialCode: dialCode, format: resolvedPattern });
        properties[key].pattern = patternRE;

        if (!properties[key].countries || properties[key].countries.length === 0) {
          properties[key].mask = _mask;
        }
        properties[key].masterFieldId = masterFieldId;
        delete properties[key].enum;
        delete properties[key].enumNames;
      }
      if (!isRequired) return;
      required.push(key);
    });
  }

  return {
    type: 'object',
    properties: properties,
    datasource_fields: _ramda2.default.isEmpty(datasourceFields) ? undefined : datasourceFields,
    required: required
  };
};

var parseUISchema = exports.parseUISchema = function parseUISchema(data) {
  if (!data) return;

  var formMetaData = data.formMetaData,
      apiRoot = data.apiRoot;

  var result = { formMetaData: formMetaData, 'ui:order': data['ui:order'] || [] };
  if (data.fields && data.fields.length) {
    data.fields.forEach(function (field, index) {
      var key = field.key,
          type = field.type,
          itemsVariable = field.itemsVariable,
          placeholder = field.placeholder,
          classNames = field.classNames,
          wrapperClassNames = field.wrapperClassNames,
          mask = field.mask,
          pattern = field.pattern,
          staticTextContent = field.staticTextContent,
          buttonType = field.buttonType,
          country = field.country,
          masterFieldId = field.masterFieldId,
          fileSizeMin = field.fileSizeMin,
          fileSizeMax = field.fileSizeMax,
          totalFilesSizeLimit = field.totalFilesSizeLimit,
          totalFilesCount = field.totalFilesCount,
          fileExtensions = field.fileExtensions,
          fileUploadHint = field.fileUploadHint,
          fileUploadButtonLabel = field.fileUploadButtonLabel,
          dateTimeWidgetType = field.dateTimeWidgetType,
          dateTimeAvailableDates = field.dateTimeAvailableDates;


      if (!key) return;

      result['ui:order'][index] = key;
      result[key] = { 'ui:apiRoot': apiRoot };

      var widgetType = widgets[type];
      if (widgetType) result[key]['ui:widget'] = widgetType;
      if (placeholder) result[key]['ui:placeholder'] = placeholder;
      if (type === 'URL' && !placeholder) result[key]['ui:placeholder'] = 'http://';
      if (itemsVariable) result[key].externalEnum = itemsVariable;
      if (classNames) result[key].classNames = classNames;
      if (wrapperClassNames) result[key]['ui:inputClassNames'] = wrapperClassNames;
      if (staticTextContent) result[key]['ui:content'] = staticTextContent;
      if (mask) result[key]['ui:mask'] = mask;
      if (masterFieldId) result[key]['ui:masterFieldId'] = masterFieldId;
      if (pattern) result[key]['ui:pattern'] = pattern;
      if (buttonType) result[key]['ui:type'] = buttonType;
      if (field.type === 'phoneInput') {
        result[key]['ui:country'] = country || countries[0].value;
        result[key]['ui:onlyCountries'] = countriesISO2;
      }
      if (type === 'filesAsync') {
        result[key] = (0, _extends3.default)({}, result[key], {
          'ui:apiUrl': apiRoot + '/forms/api/v1/uploads',
          'ui:fileSizeMin': fileSizeMin,
          'ui:fileSizeMax': fileSizeMax,
          'ui:totalFilesSizeLimit': totalFilesSizeLimit,
          'ui:totalFilesCount': totalFilesCount,
          'ui:fileExtensions': fileExtensions,
          'ui:hint': fileUploadHint,
          'ui:addButtonLabel': fileUploadButtonLabel
        });
      }
      if (type === 'datepicker') {
        result[key]['ui:dateTimeWidgetType'] = dateTimeWidgetType;
        result[key]['ui:dateTimeAvailableDates'] = dateTimeAvailableDates;
      }
    });
  }

  return result;
};

var parseFormData = exports.parseFormData = function parseFormData(data) {
  var formData = data && data.formData;
  return !_ramda2.default.isEmpty(formData) ? formData : undefined;
};

var getSchema = exports.getSchema = function getSchema(_ref2) {
  var apiRoot = _ref2.apiRoot,
      apiUrl = _ref2.apiUrl,
      formId = _ref2.formId,
      schemaId = _ref2.schemaId,
      readonlyFromConfig = _ref2.readonlyFromConfig,
      presetFromConfig = _ref2.presetFromConfig;

  var target = void 0;
  var submitMessage = void 0;

  var preset = presetFromConfig || {};
  var readonly = readonlyFromConfig || [];

  if (apiUrl) {
    target = formId ? apiUrl + '/forms/' + formId : apiUrl + '/schemas/' + schemaId;
  } else if (apiRoot) {
    target = formId ? apiRoot + '/forms/api/v1/forms/' + formId : apiRoot + '/forms/api/v1/schemas/' + schemaId;
  } else return;

  return (0, _isomorphicFetch2.default)('' + target).then(function (response) {
    return response.json().then(function (json) {
      return json;
    });
  }).then(function (json) {
    var id = _ramda2.default.prop('schemaId', json);
    return _promisePolyfill2.default.all([
    //fetch(`${target}/jsonschema`),
    //fetch(`${target}/ui`),
    _promisePolyfill2.default.resolve(json), (0, _isomorphicFetch2.default)(apiRoot + '/forms/api/v1/schemas/' + id)]);
  }).then(function (responses) {
    return _promisePolyfill2.default.all(responses.map(function (response) {
      if (!response.ok && response.url) {
        return _promisePolyfill2.default.reject('Can\'t receive form schema from ' + response.url);
      }
      // Получили уже разобранный json с данными формы (/forms/${formId)
      if (!(response instanceof Response)) return response;
      return response.json().then(function (json) {
        return json;
      });
    }));
  }).then(function (_ref3) {
    var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
        form = _ref4[0],
        rawSchema = _ref4[1];

    var schema = rawSchema.jsonschema;
    var uiSchema = rawSchema.ui;

    var fieldSettings = getFieldSettings(form);

    // Если не заданы пресеты и readonly в конфиге попробовать взять из формы
    if (!preset || (0, _keys2.default)(preset).length === 0) {
      preset = fieldSettings.preset || {};
    }

    if (!readonly || readonly.length === 0) {
      readonly = fieldSettings.readonly || [];
    }

    if (!window.fs_hidden_fields || window.fs_hidden_fields.length === 0) {
      window.fs_hidden_fields = fieldSettings.hidden || [];
    }

    (0, _createDatasourceMappings2.default)(formId, schema.properties);

    readonly.forEach(function (f) {
      if (uiSchema[f]) {
        uiSchema[f]['ui:disabled'] = true;
      }
    });

    submitMessage = rawSchema.submitMessage || form.submitMessage;

    var formName = _ramda2.default.prop('name', form);
    var cssPrefix = _ramda2.default.prop('cssPrefix', form);
    var lang = _ramda2.default.prop('lang', rawSchema);
    if (!('datasource_fields' in schema)) {
      return _promisePolyfill2.default.resolve({ schema: schema, uiSchema: uiSchema, formName: formName, cssPrefix: cssPrefix, lang: lang, form: form, submitMessage: submitMessage });
    }

    var datasource_fields = schema.datasource_fields;

    return _promisePolyfill2.default.all(datasource_fields.map(function (_ref5) {
      var id = _ref5.id,
          property = _ref5.property;

      var datasourceTarget = apiRoot ? apiRoot + '/forms/api/v1/datasource/' + id + '/feed' : apiUrl + '/datasource/' + id + '/feed';

      var dataSourceApiRoot = apiRoot ? apiRoot + '/forms/api/v1/datasource' : apiUrl + '/datasource';

      var filters = {};
      var filterFields = (0, _getFilterFields2.default)(formId, property);
      filterFields.forEach(function (row) {
        filters[row.nameInDataSource] = preset[row.nameInForm] || '';
      });

      var dataSourceUrl = (0, _buildDataSourceUrl2.default)(dataSourceApiRoot, id, filters);

      return (0, _isomorphicFetch2.default)(dataSourceUrl).then(function (response) {
        if (!response.ok) return _promisePolyfill2.default.reject('Can\'t receive datasource from ' + response.url);
        return response.json().then(function (data) {
          return {
            itemsDataSourceUrl: datasourceTarget,
            itemsDataSourceId: id,
            property: property,
            data: data
          };
        });
      });
    })).then(function (datasources) {
      return { datasources: datasources, schema: schema, uiSchema: uiSchema, formName: formName, cssPrefix: cssPrefix, lang: lang, submitMessage: submitMessage, form: form };
    });
  }).then(function (data) {
    var datasources = data.datasources,
        schema = data.schema,
        uiSchema = data.uiSchema,
        formName = data.formName,
        cssPrefix = data.cssPrefix,
        lang = data.lang,
        form = data.form,
        submitMessage = data.submitMessage;

    if (!('datasources' in data)) {
      return { schema: { schema: schema, uiSchema: uiSchema }, formName: formName, cssPrefix: cssPrefix, lang: lang, form: form, submitMessage: submitMessage };
    }
    // eslint-disable-next-line array-callback-return
    datasources.map(function (datasource) {
      /* eslint-disable no-param-reassign */
      var property = datasource.property,
          data = datasource.data;

      if ('items' in schema.properties[property]) {
        // checkboxMultiple widget
        delete schema.properties[property].items.enum;
        delete schema.properties[property].items.enumNames;
        schema.properties[property].items.enum = _ramda2.default.map(_ramda2.default.prop('id'), data);
        schema.properties[property].items.enumNames = _ramda2.default.map(_ramda2.default.prop('name'), data);

        // Если в датасорсе 0 значений - блокировать
        if (schema.properties[property].items.enum.length === 0) {
          if (uiSchema[property]) {
            uiSchema[property]['ui:disabled'] = true;
          }
        }
      } else {
        // dropdown (select) widget
        delete schema.properties[property].enum;
        delete schema.properties[property].enumNames;
        schema.properties[property].enum = _ramda2.default.map(_ramda2.default.prop('id'), data);
        schema.properties[property].enumNames = _ramda2.default.map(_ramda2.default.prop('name'), data);

        // Если в датасорсе 0 значений - блокировать
        if (schema.properties[property].enum.length === 0) {
          if (uiSchema[property]) {
            uiSchema[property]['ui:disabled'] = true;
          }
        }
      }
      schema.properties[property].itemsDataSourceUrl = datasource.itemsDataSourceUrl;
      schema.properties[property].itemsDataSourceId = datasource.itemsDataSourceId;
      schema.properties[property].itemsDataSource = data;
      /* eslint-enable no-param-reassign */
    });

    return { schema: { schema: schema, uiSchema: uiSchema }, formName: formName, cssPrefix: cssPrefix, lang: lang, submitMessage: submitMessage, form: form };
  });
};

var stringifyItem = function stringifyItem(item) {
  var key = _ramda2.default.prop('key', item);
  var value = _ramda2.default.prop('value', item);
  if (key && value) {
    if (Array.isArray(value)) {
      return key + ': ' + _ramda2.default.join(', ', value);
    }
    return key + ': ' + value;
  }
  return item;
};

var stringifyObject = exports.stringifyObject = _ramda2.default.compose(_ramda2.default.ifElse(_ramda2.default.isArrayLike, _ramda2.default.join('; '), _ramda2.default.always(null)), _ramda2.default.map(stringifyItem));

var arrifyObject = exports.arrifyObject = _ramda2.default.map(stringifyItem);
var arrifyObject2 = exports.arrifyObject2 = _ramda2.default.compose(_ramda2.default.map(_ramda2.default.join(': ')), _ramda2.default.toPairs);
var arrifyObject3 = exports.arrifyObject3 = _ramda2.default.compose(_ramda2.default.reduce(function (result, current) {
  return _ramda2.default.append({ key: current[0], value: current[1] }, result);
}, []), _ramda2.default.toPairs);

var renameKeys = exports.renameKeys = _ramda2.default.curry(function (keysMap, obj) {
  return _ramda2.default.reduce(function (acc, key) {
    return _ramda2.default.assoc(keysMap[key] || key, obj[key], acc);
  }, {}, _ramda2.default.keys(obj));
});

var renameKeysComplex = exports.renameKeysComplex = _ramda2.default.curry(function (keysMap, obj) {
  var res = _ramda2.default.map(function (item) {
    if (item == null) return undefined;

    var key = _ramda2.default.path([_ramda2.default.prop('key', item), 'title'], keysMap);

    if (key == null) return item;

    var res = _ramda2.default.assoc('key', key, item);

    return res;
  }, obj);
  return res;
});

//export const parseEnums = R.curry((keysMap, obj) => {
//  return R.reduce((acc, key) => {
//    const mapping = R.path([key, 'enums'], keysMap)
////    console.log('parseEnums keysmap', keysMap, 'mapping', mapping, 'data', obj)
//    const data = obj[key]
//    if (mapping && data) {
//      let resolvedData
//      if (R.isArrayLike(data)) {
//        resolvedData = R.props(data, mapping)
//      } else {
//        resolvedData = R.prop(data, mapping)
//      }
//      if (resolvedData) {
//        return R.assoc(key, resolvedData, acc)
//      }
//      return R.assoc(key, data, acc)
//    }
//    return R.assoc(key, data, acc)
//  }, {}, R.keys(obj))
//})
//
//const booleanMap = {
//  true: 'да',
//  false: 'нет',
//}
//
//export const parseBooleans = R.curry((keysMap, obj) => {
//  return R.reduce((acc, key) => {
//    const mapping = R.path([key, 'isBoolean'], keysMap)
//    const data = obj[key]
//    if (mapping && data != null) {
//      return R.assoc(key, R.prop(data, booleanMap), acc)
//    }
//    return R.assoc(key, data, acc)
//  }, {}, R.keys(obj))
//})

var sortData = exports.sortData = _ramda2.default.curry(function (orderMap, obj) {
  if (!orderMap) return obj;
  //  console.log('order', orderMap, 'data', obj)
  // eslint-disable-next-line array-callback-return
  var res = _ramda2.default.reduce(function (result, current) {
    var value = _ramda2.default.prop(current, obj);
    //    console.log('current', current, 'value', value)
    //    if (value) {
    return _ramda2.default.append({ key: current, value: value }, result);
    //    }
  }, [], orderMap);
  //  console.warn('result', res)
  return res;
});

var getIdFromUrl = exports.getIdFromUrl = _ramda2.default.compose(_ramda2.default.nth(-2), _ramda2.default.split('/'), _ramda2.default.path(['req', 'url']));
var extractStatuses = exports.extractStatuses = _ramda2.default.compose(_ramda2.default.map(_ramda2.default.replace(/^./, _ramda2.default.toUpper)), _ramda2.default.map(_ramda2.default.toLower), _ramda2.default.uniq, _ramda2.default.filter(_ramda2.default.identity), _ramda2.default.flatten, _ramda2.default.map(_ramda2.default.map(_ramda2.default.prop('name'))), _ramda2.default.filter(_ramda2.default.identity), _ramda2.default.map(_ramda2.default.prop('statuses')));

var extractCommonStatuses = exports.extractCommonStatuses = function extractCommonStatuses(data) {
  var parsed = _ramda2.default.compose(_ramda2.default.map(_ramda2.default.map(_ramda2.default.prop('name'))), _ramda2.default.map(_ramda2.default.propOr([], 'statuses')))(data);
  var uniqueFormsCount = parsed.length;
  return _ramda2.default.compose(_ramda2.default.filter(_ramda2.default.identity), _ramda2.default.map(function (status) {
    return _ramda2.default.compose(_ramda2.default.ifElse(_ramda2.default.propEq('true', uniqueFormsCount), _ramda2.default.always(status), _ramda2.default.always(undefined)), _ramda2.default.countBy(_ramda2.default.contains(status)))(parsed);
  }), _ramda2.default.uniq, _ramda2.default.flatten)(parsed);
};

var sanitizeString = exports.sanitizeString = function sanitizeString(value) {
  return value.replace(/(<([^>]+)>)/ig, '');
};

var transformErrors = exports.transformErrors = _ramda2.default.compose(_ramda2.default.filter(_ramda2.default.identity), _ramda2.default.map(function (error) {
  var errorArgs = void 0;
  if (['minLength', 'maxLength', 'format', 'pattern'].indexOf(error.name) !== -1) {
    var rawTitle = error.schema.title,
        argument = error.argument;

    var title = rawTitle ? '"' + sanitizeString(rawTitle) + '" ' : '';
    errorArgs = { title: title, argument: argument };
  }
  if (error.name === 'pattern' && errorArgs) {
    errorArgs.argument = error.schema.mask;
  }

  // eslint-disable-next-line no-param-reassign
  error.message = _i18next2.default.t('validation:widget.' + error.name, errorArgs);
  return error;
}));

var customValidate = exports.customValidate = function customValidate(uiSchema) {
  return function (formData, errors, dirtyFields) {
    // eslint-disable-next-line array-callback-return
    _ramda2.default.mapObjIndexed(function (schema, key) {
      if (schema['ui:widget'] === 'dateTime' && dirtyFields.indexOf(key) !== -1) {
        //      console.log('schema', schema)
        var value = _ramda2.default.prop(key, formData);
        if (!value) return errors;

        var _availableDates = _ramda2.default.prop('ui:dateTimeAvailableDates', schema);
        var widgetType = _ramda2.default.prop('ui:dateTimeWidgetType', schema);
        var format = void 0;
        var errorName = void 0;
        if (!widgetType || widgetType === 'dateTime') {
          format = 'DD.MM.YYYY HH:mm';
          if (_availableDates === 'future') {
            errorName = 'dateTimeInvalidDateTimeFuture';
          } else if (_availableDates === 'past') {
            errorName = 'dateTimeInvalidDateTimePast';
          } else {
            errorName = 'dateTimeInvalidDateTime';
          }
        } else if (widgetType === 'date') {
          format = 'DD.MM.YYYY';
          if (_availableDates === 'future') {
            errorName = 'dateTimeInvalidDateFuture';
          } else if (_availableDates === 'past') {
            errorName = 'dateTimeInvalidDatePast';
          } else {
            errorName = 'dateTimeInvalidDate';
          }
        } else if (widgetType === 'time') {
          format = 'HH:mm';
          errorName = 'dateTimeInvalidTime';
        }

        if (errorName) {
          var message = _i18next2.default.t('validation:widget.' + errorName);
          var STRICT = true;
          if (_availableDates === 'future') {
            var isInFuture = !widgetType || widgetType === 'dateTime' ? (0, _moment2.default)(value, format, STRICT).isAfter() : (0, _moment2.default)(value, format, STRICT).add(1, 'day').isAfter();
            if (!isInFuture) {
              errors[key].addError(message);
            }
          } else if (_availableDates === 'past') {
            var isInPast = (0, _moment2.default)(value, format, STRICT).isBefore();
            if (!isInPast) {
              errors[key].addError(message);
            }
          } else {
            var isValid = (0, _moment2.default)(value, format, STRICT).isValid();
            if (!isValid) {
              errors[key].addError(message);
            }
          }
        }
      }
    }, uiSchema);
    return errors;
  };
};

var langs = exports.langs = [{
  name: 'Русский',
  value: 'ru'
}, {
  name: 'Английский',
  value: 'en'
}, {
  name: 'Армянский',
  value: 'am'
}];

var eventTypes = exports.eventTypes = ['data_created', 'data_updated', 'data_deleted', 'data_status'];


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/utils/index.js
// module id = 237
// module chunks = 5